import { render, staticRenderFns } from "./DialogConsentGeneralEmailCreate.vue?vue&type=template&id=95b38d52&scoped=true&"
import script from "./DialogConsentGeneralEmailCreate.vue?vue&type=script&lang=js&"
export * from "./DialogConsentGeneralEmailCreate.vue?vue&type=script&lang=js&"
import style0 from "./DialogConsentGeneralEmailCreate.vue?vue&type=style&index=0&id=95b38d52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b38d52",
  null
  
)

export default component.exports